module.exports = __webpack_public_path__ + "static/media/greenpack.0769ebf3.png";